import '../../GlobalComponents/ReactSelect.css'

import { DropDownList } from '@progress/kendo-react-dropdowns'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { assetSelectAssetSelectedChanged } from '../../features/assetSelect/assetSelectSlice'
import { getAPIURL } from '../../GlobalComponents/URLs'

export default function AssetSelect() {
    const dispatch = useDispatch()
    const [assetTypeData, setAssetTypeData] = useState([])
    const assetSelected = useSelector((state) => state.assetSelectReducer.assetSelected)

    // Get Customer Asset Types
    React.useEffect(() => {
        let tree_url = getAPIURL() + 'lcm/customerassettypes'
        fetch(tree_url, {
            credentials: 'include',
            method: 'get',
            headers: { 'Content-type': 'application/json' },
        })
            .then((resp) => {
                if (resp.ok) {
                    return resp.json()
                } else throw new Error('bad request ' + resp.statusText)
            })
            .then((json) => {
                if (json.length > 0) {
                    setAssetTypeData(json)
                } else {
                    setAssetTypeData([])
                }
            })
            .catch((e) => {
                // Redirect to Login Page
                let redirectURL = getAPIURL().replace('/webapi/', '') + '/logon.aspx'
                if (redirectURL.toUpperCase().includes('NET'))
                    redirectURL = getAPIURL().replace('/webapi/', '') + '/masterclient/main.aspx'
                let originalURL = window.location.href
                window.location.href = redirectURL + '?Redirect=' + encodeURIComponent(originalURL)
            })
    }, [])

    function onChange(event) {
        dispatch(assetSelectAssetSelectedChanged(event.value))
    }

    return (
        <>
            <DropDownList
                data={assetTypeData}
                textField='Name'
                dataItemKey='ID'
                defaultItem={{ ID: -1, Name: 'Default' }}
                value={assetSelected}
                className='insight-Dropdown'
                onChange={onChange}
            />
        </>
    )
}
